import { encodeBoatClass } from '@/network/decoders'
import { DateFormat, ds } from '@/plugins/i18nFormat'
import BoatClass from '@model/BoatClass'
import EventRace from '@model/EventRace'
import { Model } from 'pinia-orm'
import { DateCast } from 'pinia-orm/casts'
import { Attr, BelongsTo, Cast, Num, Uid } from 'pinia-orm/decorators'

export const SPECIAL_BEHAVIOR_CONTINUOUS_START = 'continuousStart'

export default class EventRaceDetailedClass extends Model {
    static entity = 'events-races-detailed-classes'

    @Uid()
    declare id: string
    @Uid()
    declare eventRaceId: string
    @BelongsTo(() => EventRace, 'eventRaceId')
    declare race: EventRace
    @Num(0, { notNullable: true })
    declare boatClassId: number
    @BelongsTo(() => BoatClass, 'boatClassId')
    declare boatClass: BoatClass
    @Cast(() => DateCast) @Attr('')
    declare startTime: string
    @Attr(null)
    declare specialBehavior: string | null

    get dump() {
        return {
            boatClassId: encodeBoatClass(this.boatClassId),
            startTime: ds(this.startTime, DateFormat.System),
            specialBehavior: this.specialBehavior,
        }
    }

    static piniaOptions = {
        persist: true,
    }
}
